/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Intent, Size } from "@blueprintjs/core"
import { ILinksFeedPrimitiveProps } from "../LinksFeedPrimitive"
import { __ } from "src/libs/utilities"
import { SingleLinkDialog } from "../../landing-edit/editors/link/SingleLinkDialog"
import { isRole } from "src/settings/zustand/user"
import CategorySwitcher from "../../../utils/links-feed/CategorySwitcher"
import { ID, POST_STATUS, SORT_TYPE } from "src/libs/interfaces/layouts"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import updateSection from "../../landing-edit/utils/updateSection"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, ILink, LinksFeedContent } from "src/modules/pe-landing-module/data/interfaces"
import { useEffect, useState } from "react"
import { IState, useMainStore } from "src/settings/zustand"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import { onlyExistsArrays } from "src/libs/utilities/compareArrays"
import getCatsWithChildren from "../../../utils/getCatsWithChildren"

/* Protopia Ecosystem component */
export interface IFeedLinksProps extends ILinksFeedPrimitiveProps {
   children: JSX.Element
}
const FeedLinks = (props: IFeedLinksProps): JSX.Element => {
    
        const numberposts: number           = useMainStore( ( state: IState ) => state.pageCount )
        const currentLanding: ILanding      = useLandingStore( (state: ILandingStore) => state.currentLanding )
        const linkFeedCategories: ID[]      = useLandingConsoleStore( (state: ILandingConsoleStore) => state.linkFeedCategories )
        const {position}                    = usePosition( props.primitive || {position: {}} )
        const primitive: LinksFeedContent   = ( { ...props.primitive || {}, ...position.data } ) as LinksFeedContent
        const isEdit                        = useLandingStore((state: ILandingStore) => state.isEdit )
        const [sorts, setSort]              = useState<(SORT_TYPE)[]>([ SORT_TYPE.ORDER ])
    
        const getCategoriesIds = () => {
            return  primitive.categoryId || 
            ( !!linkFeedCategories?.length ? linkFeedCategories : currentLanding.categories?.map(c => c.id) ) || 
            []
        }
        const getItems = ( dist : "UP" | "DOWN" = "DOWN", categories?: ID[], status: POST_STATUS = POST_STATUS.PUBLISH ) => { 
            categories = !categories ? getCategoriesIds() : categories
            const items =  [ ...(primitive.items || []) ]
            return (
                dist === "DOWN" 
                    ? 
                    items
                    : 
                    items.reverse() 
            )
                .filter((link:ILink)  => onlyExistsArrays( link.categoryId || [],  getCatsWithChildren( categories ) ))
                .filter((link:ILink) =>!!(link.status === status))
        }
    
        const [ allItems, setAllItems ]     = useState<ILink[]>( getItems( ) ) 
        const [ isOpen, setIsOpen ]         = useState<boolean>( false ) 
        const [ currentPage, setCurrentPage ] = useState<number>( 0 ) 
        const [ distination, setDistination ] = useState<"UP" | "DOWN">( "DOWN" ) 
        const [ status, setStatus ]         = useState<POST_STATUS>( POST_STATUS.PUBLISH )  
        const [ categories, setCategories ] = useState<ID[]>( getCategoriesIds() )
    
        useEffect(() => {
            setAllItems( getItems( distination ) )
        }, [ primitive.items ])
    
        const onItemChange = (value: any, field: string, item: ILink) => {
            const section: ILandingSection = props.section! 
            const newSection = {
                ...section,
                data: section.data.map(meat => {
                    const _meat = section.data[ primitive.i || 0 ]
                    if(meat.id === _meat?.id) {
                        return {
                            ..._meat,
                            items: _meat.items.map((_item: ILink) => {
                                if(_item.url ===item.url ) {
                                    return {
                                        ..._item,
                                        [field]: value,
                                    }
                                }
                                return _item
                            })
                        }
                    }
                    return meat
                })
            }
            const step: IHistoryStep = {
                prevData: JSON.parse(JSON.stringify( section )),
                data: newSection,
                type: HISTORY_TYPE.SECTION,
                title: `Edit meat`
            }
            updateSection( newSection, step )
        }
        const onAdd = (data: ILink) => {
            const section: ILandingSection = props.section! 
            const newSection = {
                ...section,
                data: section.data.map(meat => {
                    const _meat = section.data[ primitive.i || 0 ]
                    if(meat.id === _meat?.id) {
                        return {
                            ..._meat,
                            items: [..._meat.items, data]
                        }
                    }
                    return meat
                })
            }
            const step: IHistoryStep = {
                prevData: JSON.parse(JSON.stringify( section )),
                data: newSection,
                type: HISTORY_TYPE.SECTION,
                title: `Edit meat`
            }
            updateSection( newSection, step, true ) 
            setIsOpen( false )
        }
    
        const onCategories = (categories: ID[]) => {
            setCategories( categories )
            useLandingConsoleStore.setState({ linkFeedCategories : categories })
            setAllItems( getItems( distination, categories ) )
        }
        const onStatus = (status: POST_STATUS) => {
            setStatus( status )
            setAllItems( getItems( distination, categories, status, ) )
        }
        const onDistination = (dist: "UP" | "DOWN") => {
            setDistination( dist )
            setAllItems( getItems( dist ) )
        }
        const onSortTypes = ( sortTypes: SORT_TYPE[] ) => {
            setSort( sortTypes )
        }
    
        const filteredItems = allItems
        const items = filteredItems.filter( (l, i) => i >= currentPage * numberposts && i < currentPage * numberposts + numberposts ) 
        const all = Math.ceil( filteredItems.length / numberposts ) - 1
        return <div className=' w-100' >
            <div className='pe-links-feed-container w-100' data-primitive-type={primitive["data-primitive-type"]}>
                <div className="lead mb-2" dangerouslySetInnerHTML={{__html: primitive.title || ""}} /> 
                <CategorySwitcher 
                    status={status} 
                    // primitive={ primitive } 
                    items={ filteredItems } 
                    categories={ categories } 
                    onCategories={ onCategories } 
                    onStatus={onStatus} 
                    onDistination={ onDistination }
                    onSortTypes={onSortTypes}
                    distination={distination}
                    sorts={ sorts }
                />       
                {
                    (isEdit || isRole([ "administrator" ])) && <div className="my-4">
                        <Button size={ Size.SMALL } intent={ Intent.PRIMARY } className="btn-straight py-0" icon="plus" data-select-type="ignore" onClick={ () => setIsOpen(true) }>
                            <div className="smaller">
                                {__( "Add" )}
                            </div>
                        </Button> 
                        <SingleLinkDialog isOpen={isOpen} onClose={()=>setIsOpen(false)} onAdd={ onAdd } />
                    </div>
                }
                { 
                    props.children 
                }
                {/* <div className="container-fluid px-3">
                    <div className="row">
                        { 
                            !!items.length 
                                ?
                                items.map( (link: ILink, i) => <SingleLink 
                                    key={ link.url } 
                                    i={ i } 
                                    data={ link } 
                                    items={ items } 
                                    primitive={ primitive }
                                    columns={ primitive.columns }  
                                    section={ props.section }
                                    onChange={( value: any, field: string, ) => onItemChange( value, field, link )} 
                                /> ) 
                                :
                                <CalloutNoExists />
                        }
                    </div>
                </div>
                <Pagi 
                    all={  all >= 0 ? all : 0 }
                    current={ Math.ceil( currentPage / numberposts ) } 
                    onChoose={ n => setCurrentPage( n )}
                />  */}
                {
                    (isEdit || isRole([ "administrator" ])) && <div className="my-4">
                        <Button size={ Size.SMALL } intent={ Intent.PRIMARY } className="btn-straight py-0" icon="plus" data-select-type="ignore" onClick={ () => setIsOpen(true) }>
                            <div className="smaller">
                                {__( "Add" )}
                            </div>
                        </Button> 
                    </div>
                }
            </div>
           
        </div> 
}
export default FeedLinks